module.exports = __webpack_public_path__ + "static/img/solution-y-4.707d551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-y-4.png
// module id = DP/b
// module chunks = 10